import React from 'react';
import { FaCheckCircle } from "react-icons/fa";

const IconText = ({
    text,
    className = "text-gray-600 flex items-center",
    iconClass = "text-secondary mr-2 flex-shrink-0",
    iconSize = 18,
    Icon = FaCheckCircle
}) => {
    return (
        <div className={`flex items-center ${className.trim()}`}>
            <Icon className={iconClass} size={iconSize} />
            <span>{text}</span>
        </div>
    );
};

export default IconText;
